// Copyright (c) 2016 Deere & Company

import PartsClaim from './components';
import actionCreators from './action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.claims.parts,
    isCkcCustomerFailed: state.customerFailed.ckcCustomerFailed,
    latestPerUnitMeasurements: state.latestPerUnitMeasurements,
    partsGroupedByPartNumber: state.claims.partsGroupedByPartNumber,
    warranties: state.productDetails.warranties

});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    const queryParams = parentProps.location.query;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        queryParams,
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(PartsClaim);



// WEBPACK FOOTER //
// ./src/claim/parts/state-connector.js